import React from 'react';

export default function Panel({
  icon = null,
  title,
  subtitle = null,
  children,
}) {
  return (
    <section className='features-section'>
      <div className='container'>
        <div className='sample-workout-panel'>
          <div className='sample-header'>
            {icon ? <div className='sample-icon'>{icon}</div> : null}
            {title ? <h3>{title}</h3> : null}
            {subtitle ? <p className='sample-subtitle'>{subtitle}</p> : null}
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}
